import React from 'react';
import { useSnackbar } from 'notistack';

const ButtonCloseSnackbarComponent = (props: any) => {
    const { closeSnackbar } = useSnackbar();
    return <button className='button-close-snackbar' onClick={() => closeSnackbar(props.id)}>x</button>;
}

export default ButtonCloseSnackbarComponent